/**
 * Hook de datos de los **descuadres** (`GET /api/v1/talonarios/mismatches`).
 *
 * Datos de servidor -> TanStack Query. La query key incluye la sede activa y los
 * filtros (fechas/trabajador) para cachear por combinación. La red la gobierna
 * `lib/api`. `placeholderData: keepPreviousData` evita el parpadeo al refiltrar.
 */
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { getActiveSedeId } from "@/lib/sede";

import { fetchTalonarioMismatches } from "../api";
import type {
  TalonarioMismatchesQuery,
  TalonarioMismatchesResponse,
} from "../types";
import { talonarioMismatchesQueryKey } from "./queryKeys";

export function useTalonarioMismatches(query: TalonarioMismatchesQuery) {
  const sedeId = getActiveSedeId();
  return useQuery<TalonarioMismatchesResponse>({
    queryKey: talonarioMismatchesQueryKey(sedeId, query),
    queryFn: () => fetchTalonarioMismatches(query),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  });
}
